class ScrollingTimeline extends HTMLElement {
  constructor() {
    super();
    this.layoutUpdaters = [];
  }

  _initializeAndUpdateLayoutGSAP() {
    // const totalHeight = Array.from(this.timelineItems).reduce((acc, item) => {
    //   return (
    //     acc +
    //     this._calculateFullContentHeight(
    //       item.querySelector(".pleto-timeline-content"),
    //     )
    //   );
    // }, 0);

    if (this.isScrollAnimationDisabled) {
      return;
    }

    const scrollingTimeline = this;
    if(this.tween && this.tween.scrollTrigger) {
      this.tween.scrollTrigger.refresh(true);
      return;
    }
    this.tween = gsap.to(scrollingTimeline.closest(".pleto-timeline"), {
      ease: "none", // A linear ease ensures the speed matches the scroll speed.
      scrollTrigger: {
        trigger: this.closest(".pleto-timeline"),
        // MODIFIED: Start when the center of the trigger hits the center of the viewport
        start: "center center",
        end: () => `bottom center-=30%`,
        scrub: 1,
        anticipatePin: 1,
        pin: true,
        onUpdate: function (tween) {
          scrollingTimeline._updateDotMetrics(tween.progress);
        },
      },
    });
  }
  connectedCallback() {

    const debouncedUpdateLayout = this._debounce(
    () => {
          this._initializeAndUpdateLayoutGSAP();
    },
    400);

    this.isScrollAnimationDisabled = this.hasAttribute(
      "data-disable-scroll-animation"
    );

    if (!this.connectedCallbackCalled) {
      this.connectedCallbackCalled = true;
    } else return;
    this.allAccordionHeaders = this.querySelectorAll(".pleto-accordion-header");
    this.timelineItems = this.querySelectorAll(".pleto-timeline-item");
    this.progressDot = this.querySelector(".pleto-progress-dot");
    this.timelineContainer = this;
    this.timelineContents = this.querySelectorAll(".pleto-timeline-content");
    this.mainAccordionHeaders = this.querySelectorAll(
      ".pleto-main-accordion-header",
    );
    this.wrapper = this.querySelector(".pleto-timeline-items");
    this.animateInnerAccordion = this.hasAttribute(
      "data-animate-inner-accordion",
    );
    this.openAllAccordions = this.hasAttribute(
      "data-open-all-accordions",
    );

    if (window.innerWidth < 749) {
      document.addEventListener("DOMContentLoaded", () => {
        if (this.openAllAccordions) {
          this._openAllAccordionsByDefault();
        } else {
          this._openFirstAccordionByDefault();
        }
        if (!this.isScrollAnimationDisabled) {
          setTimeout(() => {
            this._initializeAndUpdateLayoutGSAP();
          }, 1500);
        }
      });

      this.mainAccordionHeaders.forEach((header) => {
        header.addEventListener(
          "click",
          this._handleMainAccordionClick.bind(this),
        );
      });
    } else if (!this.isScrollAnimationDisabled) {
      document.addEventListener("DOMContentLoaded", () => {
        if (this.openAllAccordions) {
          this._openAllAccordionsByDefault();
        } else {
          this._openFirstAccordionByDefault();
        }
        setTimeout(() => {
          this._initializeAndUpdateLayoutGSAP();
        }, 100);
      });
    } else {
      if (this.openAllAccordions) {
        this._openAllAccordionsByDefault();
      } else {
        this._openFirstAccordionByDefault();
      }
    }

    this.allAccordionHeaders.forEach((header) => {
      header.addEventListener(
        "click",
        this._handleInnerAccordionClick.bind(this),
      );
    });

    // if (!this.timelineItems.length) return;

    // this.pageScroll_AnimationStart = undefined;
    // this.animationScrollRange = undefined;
    // this.currentY = 0;

    // this._initializeAndUpdateLayout =
    //   this._initializeAndUpdateLayout.bind(this);
    // this._updateProgressDotPosition =
    //   this._updateProgressDotPosition.bind(this);
    // this._handleShopifyBlockSelect = this._handleShopifyBlockSelect.bind(this);

    // this._openFirstAccordionByDefault();
    // this._initializeAndUpdateLayout();

    // if (this.wrapper) {
    //   requestAnimationFrame(() => this._animate());
    // }

    // this.mainAccordionHeaders.forEach((header) => {
    //   header.addEventListener(
    //     "click",
    //     this._handleMainAccordionClick.bind(this),
    //   );
    // });

    // this.allAccordionHeaders.forEach((header) => {
    //   header.addEventListener(
    //     "click",
    //     this._handleInnerAccordionClick.bind(this),
    //   );
    // });


    // window.addEventListener("scroll", this._updateProgressDotPosition);

    // if (window.Shopify && window.Shopify.designMode) {
    //   document.addEventListener(
    //     "shopify:section:load",
    //     this._initializeAndUpdateLayout,
    //   );
    //   document.addEventListener(
    //     "shopify:section:reorder",
    //     this._initializeAndUpdateLayout,
    //   );
    //   document.addEventListener(
    //     "shopify:block:select",
    //     this._handleShopifyBlockSelect,
    //   );
    // }



    if (!this.isScrollAnimationDisabled) {
      if (window.innerWidth < 749) {
        this.bodyObserver = new ResizeObserver(
          debouncedUpdateLayout,
        );
        this.bodyObserver.observe(document.body);
      }

      window.addEventListener("resize", debouncedUpdateLayout);
    }
    // this._initStickyStateTracking();
  }

  disconnectedCallback() {
  //   window.removeEventListener("resize", this._initializeAndUpdateLayout);
  //   window.removeEventListener("scroll", this._updateProgressDotPosition);

  //   if (window.Shopify && window.Shopify.designMode) {
  //     document.removeEventListener(
  //       "shopify:section:load",
  //       this._initializeAndUpdateLayout,
  //     );
  //     document.removeEventListener(
  //       "shopify:section:reorder",
  //       this._initializeAndUpdateLayout,
  //     );
  //     document.removeEventListener(
  //       "shopify:block:select",
  //       this._handleShopifyBlockSelect,
  //     );
  //   }

  }

  _debounce(callback, wait) {
    let timeoutId = null;

    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        callback.apply(this, args);
      }, wait);
    };
  }

  _handleMainAccordionClick(event) {
    const parentTimelineContent = event.currentTarget.closest(
      ".pleto-timeline-content",
    );
    if (!parentTimelineContent) return;

    const clickedItemIndex = Array.from(this.timelineContents).indexOf(
      parentTimelineContent,
    );
    if (
      clickedItemIndex === -1
    )
      return;

    if (this.isScrollAnimationDisabled) {
      // In fixed mode, simply toggle the clicked accordion
      const isActive = parentTimelineContent.classList.contains("active");
      const mainContent = parentTimelineContent.querySelector(".pleto-main-accordion-content");
      const mainHeader = parentTimelineContent.querySelector(".pleto-main-accordion-header");

      if (isActive) {
        parentTimelineContent.classList.remove("active");
        if (mainHeader) mainHeader.classList.remove("active");
        if (mainContent) mainContent.style.height = "0px";
      } else {
        // Close other accordions
        this.timelineContents.forEach((tc) => {
          const otherMainContent = tc.querySelector(".pleto-main-accordion-content");
          const otherMainHeader = tc.querySelector(".pleto-main-accordion-header");
          tc.classList.remove("active");
          if (otherMainHeader) otherMainHeader.classList.remove("active");
          if (otherMainContent) otherMainContent.style.height = "0px";
        });

        // Open the clicked accordion
        parentTimelineContent.classList.add("active");
        if (mainHeader) mainHeader.classList.add("active");
        if (mainContent) {
          mainContent.style.height = this._calculateCurrentMainAccordionContentHeight(mainContent) + "px";
        }
      }
      return;
    }

    const itemCount = this.timelineContents.length;
    if (itemCount === 0) return;
    // Get the start and end scroll positions from the tween's scrollTrigger
    const scrollTrigger = this.tween.scrollTrigger;
    if (scrollTrigger) {
      const start = scrollTrigger.start;
      const end = scrollTrigger.end;
      const targetProgress = clickedItemIndex / itemCount + 0.5 / itemCount;
      const targetScrollY = start + (end - start) * targetProgress;
      window.scrollTo({
        top: targetScrollY,
        behavior: "smooth",
      });
    }
    if (this.animationScrollRange > 0) targetScrollY += 1;
  }

  _handleInnerAccordionClick(event) {
    const header = event.currentTarget;
    const isActive = header.classList.contains("active");
    const content = header.nextElementSibling;
    const parentMainContent = header.closest(".pleto-main-accordion-content");
    const otherHeaders = parentMainContent.querySelectorAll(
      ".pleto-accordion-header.active",
    );
    if (isActive) {
      header.classList.remove("active");
      content.style.height = "0px";
    } else {
      content.style.height = content.scrollHeight + "px";
      header.classList.add("active");
      otherHeaders.forEach((otherHeader) => {
        if (otherHeader !== header) {
          otherHeader.classList.remove("active");
          otherHeader.nextElementSibling.style.height = "0px";
        }
      });
    }

    if (parentMainContent && parentMainContent.style.height !== "0px") {
      const newParentHeight =
        this._calculateCurrentMainAccordionContentHeight(parentMainContent);
      parentMainContent.style.height = newParentHeight + "px";
    }
    // this._refreshScrollTrigger();
  }

  _refreshScrollTrigger() {
    const pinSpacer = this.closest(".pin-spacer");
    const prevHeight = pinSpacer.style.height;
    const prevPadding = pinSpacer.style.padding;
    // pinSpacer.style.minHeight = pinSpacer.style.height;
    // pinSpacer.style.maxHeight = pinSpacer.style.height;

    setTimeout(() => {
      if (this.tween && this.tween.scrollTrigger) {
        pinSpacer.style.transition =
          "height 1000s ease-out, padding 1000s ease-out";
        this.tween.scrollTrigger.refresh();
        const newHeight = pinSpacer.style.height;
        const newPadding = pinSpacer.style.padding;
        pinSpacer.style.height = prevHeight;
        pinSpacer.style.padding = prevPadding;
        setTimeout(() => {
          pinSpacer.style.transition =
            "height 0.3s ease-out, padding 0.3s ease-out";
          pinSpacer.style.height = newHeight;
          pinSpacer.style.padding = newPadding;
        }, 100); // Delay to ensure the previous height is rendered before starting the transition
      }
    }, 300);
  }

  _handleShopifyBlockSelect(e) {
    const selectedBlock = e.target;
    if (
      selectedBlock &&
      selectedBlock.classList.contains("pleto-timeline-item")
    ) {
      const header = selectedBlock.querySelector(
        ".pleto-main-accordion-header",
      );
      if (header) header.click();
    }
  }

  _openFirstAccordionByDefault() {
    if (this.timelineContents.length > 0) {
      const firstTimelineContent = this.timelineContents[0];
      const mainContent = firstTimelineContent.querySelector(
        ".pleto-main-accordion-content",
      );
      const mainHeader = firstTimelineContent.querySelector(
        ".pleto-main-accordion-header",
      );

      if (mainContent && mainHeader) {
        mainHeader.classList.add("active");
        firstTimelineContent.classList.add("active");

        // const firstInnerAccordion = mainContent.querySelector(
        //   ".pleto-accordion-wrapper",
        // );
        // if (firstInnerAccordion) {
        //   const header = firstInnerAccordion.querySelector(
        //     ".pleto-accordion-header",
        //   );
        //   const content = firstInnerAccordion.querySelector(
        //     ".pleto-accordion-content",
        //   );
        //   if (header && content) {
        //     header.classList.add("active");
        //     content.style.height = content.scrollHeight + "px";
        //   }
        // }
        mainContent.style.height =
          this._calculateCurrentMainAccordionContentHeight(mainContent) + "px";
      }
    }
  }

  _openAllAccordionsByDefault() {
    this.timelineContents.forEach((timelineContent) => {
      const mainContent = timelineContent.querySelector(
        ".pleto-main-accordion-content",
      );
      const mainHeader = timelineContent.querySelector(
        ".pleto-main-accordion-header",
      );

      if (mainContent && mainHeader) {
        mainHeader.classList.add("active");
        timelineContent.classList.add("active");
        mainContent.style.height =
          this._calculateCurrentMainAccordionContentHeight(mainContent) + "px";
      }
    });
  }

  _updateStickyTopOffset() {
    document.documentElement.style.setProperty(
      "--pleto-sticky-top-offset",
      "0px",
    );
  }

  _lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  _animate() {
    if (!this.wrapper) return;

    const rect = this.wrapper.getBoundingClientRect();
    const activeItem = this.querySelector(".pleto-timeline-content.active");

    if (!activeItem) {
      return requestAnimationFrame(() => this._animate());
    }

    const activeItemIndex = Array.from(this.timelineContents).indexOf(
      activeItem,
    );
    const itemsBeforeActive = Array.from(this.timelineContents).slice(
      0,
      activeItemIndex,
    );
    let totalHeightBeforeActive = 0;
    itemsBeforeActive.forEach((item) => {
      totalHeightBeforeActive +=
        item.querySelector(".pleto-main-accordion-header").offsetHeight + 40;
    });

    const target = Math.max(20, window.innerHeight / 2 - rect.height / 2);
    this.currentY = this._lerp(
      this.currentY,
      target - totalHeightBeforeActive,
      0.05,
    );
    this.wrapper.style.transform = `translateY(0px)`;
    requestAnimationFrame(() => this._animate());
  }

  _calculateCurrentMainAccordionContentHeight(mainAccordionContentEl) {
    if (!mainAccordionContentEl) return 0;
    let currentHeight = 0;
    const accordionWrappers = mainAccordionContentEl.querySelectorAll(
      ".pleto-accordion-wrapper",
    );
    accordionWrappers.forEach((wrapper) => {
      const wrapperStyle = window.getComputedStyle(wrapper);
      currentHeight +=
        parseInt(wrapperStyle.marginTop) + parseInt(wrapperStyle.marginBottom);
      const header = wrapper.querySelector(".pleto-accordion-header");
      if (header) currentHeight += header.offsetHeight;
      const innerAccordionContent = wrapper.querySelector(
        ".pleto-accordion-content",
      );
      if (
        innerAccordionContent &&
        innerAccordionContent.style.height &&
        innerAccordionContent.style.height !== "0px"
      ) {
        currentHeight += innerAccordionContent.scrollHeight;
      }
    });
    return currentHeight;
  }

  _calculateFullContentHeight(contentElement) {
    let totalHeight = 0;
    const style = window.getComputedStyle(contentElement);
    totalHeight += parseInt(style.paddingTop) + parseInt(style.paddingBottom);

    const mainHeader = contentElement.querySelector(
      ".pleto-main-accordion-header",
    );
    if (mainHeader) {
      const mainHeaderStyle = window.getComputedStyle(mainHeader);
      totalHeight += mainHeader.offsetHeight;
      totalHeight +=
        parseInt(mainHeaderStyle.marginTop) +
        parseInt(mainHeaderStyle.marginBottom);
    }

    const mainAccordionContentEl = contentElement.querySelector(
      ".pleto-main-accordion-content",
    );
    if (mainAccordionContentEl) {
      totalHeight += this._getPotentialMainAccordionContentHeight(
        mainAccordionContentEl,
      );
    }
    return totalHeight;
  }

  _getPotentialMainAccordionContentHeight(mainAccordionContentEl) {
    if (!mainAccordionContentEl) return 0;

    let potentialHeight = 0;
    const accordionWrappers = mainAccordionContentEl.querySelectorAll(
      ".pleto-accordion-wrapper",
    );

    accordionWrappers.forEach((wrapper) => {
      const wrapperStyle = window.getComputedStyle(wrapper);
      potentialHeight +=
        parseInt(wrapperStyle.marginTop) + parseInt(wrapperStyle.marginBottom);

      const header = wrapper.querySelector(".pleto-accordion-header");
      if (header) {
        potentialHeight += header.offsetHeight;
      }
      const innerAccordionContent = wrapper.querySelector(
        ".pleto-accordion-content",
      );
      if (innerAccordionContent) {
        const originalInnerHeight = innerAccordionContent.style.height;
        const originalInnerDisplay = innerAccordionContent.style.display;

        innerAccordionContent.style.display = "block";
        innerAccordionContent.style.height = "auto";

        potentialHeight += innerAccordionContent.scrollHeight;

        innerAccordionContent.style.height = originalInnerHeight;
        innerAccordionContent.style.display = originalInnerDisplay;
      }
    });
    return potentialHeight;
  }

  _updateDotMetrics(progress) {
    if (!this.timelineContainer || !this.progressDot) return;

    const headerH = 0;
    const containerTop = this.timelineContainer.offsetTop;
    const containerHeight = this.timelineContainer.offsetHeight;
    const viewportH = window.innerHeight;

    if (containerHeight <= 0) {
      this.pageScroll_AnimationStart = undefined;
      this.animationScrollRange = undefined;
      this.progressDot.style.display = "none";
      return;
    }

    this.pageScroll_AnimationStart = containerTop - headerH;
    const pageScroll_AnimationEnd = containerTop + containerHeight - viewportH;
    this.animationScrollRange =
      pageScroll_AnimationEnd - this.pageScroll_AnimationStart;

    this.progress = progress || 0;

    this._updateProgressDotPosition();
  }

  _updateMainAccordions() {
    if (
      !this.timelineItems.length ||
      this.pageScroll_AnimationStart === undefined ||
      this.animationScrollRange === undefined
    ) {
      this.timelineContents.forEach((tc) => {
        const mainContent = tc.querySelector(".pleto-main-accordion-content");
        if (mainContent) mainContent.style.height = "0px";
        tc.classList.remove("active");
      });
      return;
    }

    const currentOverallScrollProgress = this.progress;

    const itemCount = this.timelineItems.length;
    let activeItemIndex = Math.floor(currentOverallScrollProgress * itemCount);
    const nextItemScrollProgress =
      currentOverallScrollProgress * itemCount - activeItemIndex;
    if (activeItemIndex >= itemCount && itemCount > 0)
      activeItemIndex = itemCount - 1;

    this.timelineContents.forEach((tc, index) => {
      const mainContent = tc.querySelector(".pleto-main-accordion-content");
      if (!mainContent) return;
      if (nextItemScrollProgress === 0) return;
      if (index === activeItemIndex) {
        if (!tc.classList.contains("active")) {
          tc.classList.add("active");
          const potentialHeight =
            this._calculateCurrentMainAccordionContentHeight(mainContent);
          mainContent.style.height = potentialHeight + "px";

          // if (!this.animateInnerAccordion) {
          //   // Open the first inner accordion by default
          //   const firstInnerAccordion = mainContent.querySelector(
          //     ".pleto-accordion-wrapper",
          //   );
          //   if (firstInnerAccordion) {
          //     const header = firstInnerAccordion.querySelector(
          //       ".pleto-accordion-header",
          //     );
          //     const content = firstInnerAccordion.querySelector(
          //       ".pleto-accordion-content",
          //     );
          //     if (header && content) {
          //       header.classList.add("active");
          //       content.style.height = content.scrollHeight + "px";
          //     }
          //   }
          // }
        }
        if (this.animateInnerAccordion) {
          const innerAccordions = mainContent.querySelectorAll(
            ".pleto-accordion-wrapper",
          );
          innerAccordions.forEach((accordion, innerIndex) => {
            const header = accordion.querySelector(".pleto-accordion-header");
            const content = accordion.querySelector(".pleto-accordion-content");
            if (header && content) {
              if (
                innerIndex ===
                Math.floor(nextItemScrollProgress * innerAccordions.length)
              ) {
                header.classList.add("active");
                content.style.height = content.scrollHeight + "px";
              } else {
                header.classList.remove("active");
                content.style.height = "0px";
              }
            }
          });
          mainContent.style.height =
            this._calculateCurrentMainAccordionContentHeight(mainContent) +
            "px";
        }
      } else {
        if (tc.classList.contains("active")) {
          tc.classList.remove("active");
          mainContent.style.height = "0px";
        }
      }
    });
  }

  _updateProgressDotPosition() {
    if (!this.progressDot) return;

    const headerH = 0;
    const viewportH = window.innerHeight;
    const availableViewportH_ForDot = viewportH - headerH;
    let currentScrollProgress = 0;

    if (
      this.pageScroll_AnimationStart !== undefined &&
      this.animationScrollRange !== undefined
    ) {
      const actualScrollY = window.pageYOffset;
      if (this.animationScrollRange <= 0) {
        currentScrollProgress =
          actualScrollY >= this.pageScroll_AnimationStart ? 1 : 0;
      } else {
        currentScrollProgress =
          (actualScrollY - this.pageScroll_AnimationStart) /
          this.animationScrollRange;
        currentScrollProgress = Math.max(0, Math.min(1, currentScrollProgress));
      }
    }

    const dotTopMin_InAvailable = 0.1 * availableViewportH_ForDot;
    const dotTopMax_InAvailable = 0.95 * availableViewportH_ForDot;
    const currentDotOffsetInAvailable =
      dotTopMin_InAvailable +
      currentScrollProgress * (dotTopMax_InAvailable - dotTopMin_InAvailable);
    const newDotTopStyleValue = headerH + currentDotOffsetInAvailable;
    this.progressDot.style.top = newDotTopStyleValue + "px";

    this._updateMainAccordions();
  }

  _initializeAndUpdateLayout() {
    const totalHeight = Array.from(this.timelineItems).reduce((acc, item) => {
      return (
        acc +
        this._calculateFullContentHeight(
          item.querySelector(".pleto-timeline-content"),
        ) *
          1.2
      );
    }, 0);
    this.style.height = totalHeight + "px";

    this._updateStickyTopOffset();
    this._updateDotMetrics();
  }

  _initStickyStateTracking() {
    const stickyElements = this.querySelectorAll("[data-track-sticky]");

    stickyElements.forEach((stickyEl) => {
      if (stickyEl.dataset.trackingInitialized) {
        return;
      }
      stickyEl.dataset.trackingInitialized = "true";

      const parentEl = stickyEl.parentElement;
      if (!parentEl) {
        return;
      }

      const startSentinel = document.createElement("div");
      startSentinel.classList.add("sticky-sentinel");
      stickyEl.before(startSentinel);

      const endSentinel = document.createElement("div");
      endSentinel.classList.add("sticky-sentinel");
      parentEl.append(endSentinel);

      const stickyElTop = parseInt(window.getComputedStyle(stickyEl).top);

      const startObserver = new IntersectionObserver(
        ([entry]) => {
          stickyEl.classList.toggle("has-stuck-top", !entry.isIntersecting);
          this._updateStickyState(stickyEl);
        },
        {
          rootMargin: `-${stickyElTop}px 0px 0px 0px`,
          threshold: [0],
        },
      );

      const endObserver = new IntersectionObserver(
        ([entry]) => {
          stickyEl.classList.toggle("is-at-end", entry.isIntersecting);
          this._updateStickyState(stickyEl);
        },
        {
          rootMargin: `-${stickyElTop}px 0px 0px 0px`,
          threshold: [0],
        },
      );

      startObserver.observe(startSentinel);
      endObserver.observe(endSentinel);
    });
  }

  _updateStickyState(stickyEl) {
    const hasStuckTop = stickyEl.classList.contains("has-stuck-top");
    const isAtEnd = stickyEl.classList.contains("is-at-end");

    stickyEl.classList.toggle("is-stuck", hasStuckTop && !isAtEnd);
  }
}

customElements.define("scrolling-timeline", ScrollingTimeline);
